import React, { Component } from 'react';
import { connect } from "react-redux";
import { randomQuote } from '../../../redux/selectors'
import './quote.css';

class Quote extends Component {
  render() {
    const { quote } = this.props;

    return quote && <div className='quoteBlock'>
      <p className='quote center italic accent'>"{quote.quote}"</p>
      <p className='italic center'>- {quote.owner} -</p>
    </div>
  }
}

function mapStateToProps(state) {
  return {
    quote: randomQuote(state),
    quotes: state.firestore.data.quotes
  };
}

export default connect(mapStateToProps)(Quote);
